module.exports = __webpack_public_path__ + "img/turbo_on.161a1075.png";